import React from 'react';
interface ToggleProps {
  options: string[];
  activeIndex: number;
  onChange: (index: number) => void;
  className?: string;
}
export const Toggle: React.FC<ToggleProps> = ({
  options,
  activeIndex,
  onChange,
  className = ''
}) => {
  return <div className={`inline-flex bg-gray-100 p-1 rounded-full ${className}`} data-id="element-578">
      {options.map((option, index) => <button key={index} className={`px-6 py-2 text-sm font-medium rounded-full transition-all ${activeIndex === index ? 'bg-white text-primary shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => onChange(index)} data-id="element-579">
          {option}
        </button>)}
    </div>;
};